import React, { useEffect, useState } from "react";
import axios from "axios";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import { API_URL } from "../../../utils/Common";
import CantidadCamas from "./CantidadCamas";

const AsignacionValvulas = (props) => {
   const planId = props.match.params.id; // -- el ID del plan

   const [plan, setPlan] = useState({});
   const [ranchosVal, setRanchosVal] = useState([]);

   useEffect(() => {
      axios
         .get(API_URL + "/getInfoAsignacionValvulas", { params: { planId } })
         .then((r) => {
            console.log(r.data);
            setPlan(r.data.plan);
            setRanchosVal(r.data.ranchos);
         })
         .catch((e) => console.log(e));
   }, [planId]);

   const asignar = (v, r) => {
      props.history.push("/asignacion_camas/" + planId + "/" + v.id);
   };

   return (
      <div className="w-full p-3 right-0">
         <div className="bg-white border rounded shadow-xl">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo="Asignación de Válvulas" history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               {plan.hasOwnProperty("tipoFlor") && (
                  <h1 className="text-orange-900 font-bold">
                     {plan.tipoFlor.flor.nombre_comun} {plan.tipoFlor.variedades.nombre}{" "}
                     {plan.tipoFlor.color.descripcion}
                     <p className="text-orange-700 mb-5 border-b-2 border-orange-800">
                        Requrimiento:{" "}
                        {(
                           (plan.total_entregado * plan.por_germinacion * plan.tipoFlor.flor.cavidad) /
                           plan.tipoFlor.flor.densidadm2
                        ).toFixed(2)}{" "}
                        m2
                     </p>
                  </h1>
               )}
               {/** ----- INVENTARIO DE CAMPO */}
               {ranchosVal.map((r, i) => {
                  return (
                     <table key={i} className="mb-5 shadow">
                        <caption className="text-left text-orange-900 font-bold bg-orange-200 py-1 px-1 border border-orange-800">
                           {r.nombre}
                        </caption>
                        <thead>
                           <tr className="border border-orange-800 text-white content-center bg-orange-800">
                              <th className="px-4 py-2">Valvula</th>
                              <th className="px-4 py-2">Disponible (m2)</th>
                              <th className="px-4 py-2">Requeridos (m2)</th>
                              <th className="px-4 py-2">Total Camas</th>
                              <th className="px-4 py-2">Camas Disponibles</th>
                              <th className="px-4 py-2">Camas Requeridas</th>
                              <th className="px-4 py-2">Acciones</th>
                           </tr>
                        </thead>
                        <tbody>
                           {r.valvulas.map((v, j) => {
                              return (
                                 <tr key={j}>
                                    <td className="text-center border px-4 py-2">{v.codigo}</td>
                                    <td className="text-right border px-4 py-2">{v.disponiblesm2}</td>
                                    <td className="text-right border px-4 py-2">
                                       {(
                                          (plan.total_entregado * plan.por_germinacion * plan.tipoFlor.flor.cavidad) /
                                          plan.tipoFlor.flor.densidadm2
                                       ).toFixed(2)}
                                    </td>
                                    <td className="text-right border px-4 py-2 w-1">{v.no_camas}</td>
                                    <td className="text-right border px-4 py-2 w-1">{v.camasDisponibles}</td>
                                    <td className="text-center border px-4 py-2 w-1">
                                       <CantidadCamas
                                          value={(
                                             (plan.total_entregado *
                                                plan.por_germinacion *
                                                plan.tipoFlor.flor.cavidad) /
                                             plan.tipoFlor.flor.densidadm2 /
                                             v.largo
                                          ).toFixed(2)}
                                       />
                                    </td>
                                    <td className="text-center border px-4 py-2">
                                       <button
                                          className="text-white bg-orange-800 px-2 py-1 rounded"
                                          onClick={() => asignar(v, r)}
                                       >
                                          Asignar
                                       </button>
                                    </td>
                                 </tr>
                              );
                           })}
                        </tbody>
                     </table>
                  );
               })}
            </div>
         </div>
      </div>
   );
};

export default AsignacionValvulas;
